import {
    createActionCreators,
    createReducerFunction,
    ImmerReducer
} from 'immer-reducer';

import Status from '~/constants/Status';
import FCMData from '~/types/FCMData';

interface ManageFCMModuleState {
    status: Status;
    data: FCMData;
}

const initializeState: ManageFCMModuleState = {
    status: Status.INITIAL,
    data: {
        token: null,
        deviceID: null,
        locale: null,
        osVersion: null,
        appVersion: null,
        userInfo: null,
        enabled: false
    }
};

class ManageFCMModule extends ImmerReducer<ManageFCMModuleState> {
    reset() {
        this.draftState = initializeState;
    }

    initialize(initData: ManageFCMModuleState['data']) {
        if (this.draftState.status !== Status.INITIAL) return;

        this.draftState.status = Status.SUCCESS;
        this.draftState.data = {
            ...initData
        };
    }

    syncFCMData() {}
    syncFCMDataSuccess(syncData: ManageFCMModuleState['data']) {
        if (this.draftState.status !== Status.SUCCESS) return;

        this.draftState.data = {
            ...syncData
        };
    }

    updateFCMData() {}
    updateFCMDataSuccess(
        newData: Partial<Omit<ManageFCMModuleState['data'], 'enabled'>>
    ) {
        if (this.draftState.status !== Status.SUCCESS) return;

        this.draftState.data = {
            ...this.draftState.data,
            ...newData
        };
    }

    updateEnabledWithPermission(enabled: boolean) {}
    updateEnabled(enabled: boolean) {}
    setEnabled(enabled: boolean) {
        if (this.draftState.status !== Status.SUCCESS) return;

        this.draftState.data.enabled = enabled;
    }
}

export const manageFCMReducer = createReducerFunction(
    ManageFCMModule,
    initializeState
);
export const manageFCMAction = createActionCreators(ManageFCMModule);
